module.exports = __webpack_public_path__ + "media/idle.0d1cb2e1.webm";